import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormErrorEvents } from './types';

export enum OrdersEnum {
  dataOraPubblicazione = 'eventoPubblicato.dataOraPubblicazione',
  codiceTipoEvento = 'iscrizioneEvento.tipoEvento.codice',
  sottoscrittoreDescrizione = 'iscrizioneEvento.sottoscrittore.descrizione',
}
export const transformDataset = (values: FiltersFormErrorEvents): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    aDataOra: {
      value: otherValues.dateTimePublicationTo
        ? otherValues.dateTimePublicationTo.toFormat(`yyyy-MM-dd'T'HH:mm:ss`)
        : '',
    },
    codiceSottoscrittore: {
      value: otherValues.subscriber,
    },
    codiceTipoDestinazione: {
      value: otherValues.typeDestinationCode,
    },
    codiceTipoEvento: {
      value: otherValues.typeEventCode,
    },
    statoElaborazione: {
      value: otherValues.state,
    },
    daDataOra: {
      value: otherValues.dateTimePublicationFrom
        ? otherValues.dateTimePublicationFrom.toFormat(`yyyy-MM-dd'T'HH:mm:ss`)
        : '',
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    'iscrizioneEvento.sottoscrittore.descrizione': ordersToTransform.subscriber,
    id: ordersToTransform.id,
    'eventoPubblicato.dataOraPubblicazione': ordersToTransform.dataTime,
    'iscrizioneEvento.tipoEvento.codice': ordersToTransform.typeEventCode,
    statoElaborazione: ordersToTransform.state,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
